import React from "react";
import { MusicalNoteIcon } from "@heroicons/react/24/solid";

function PricingSection(props) {

  return (
    <section className="py-12">
      <div className="container mx-auto px-8 max-w-3xl my-10">
        <h1 className="mb-6 text-4xl font-medium text-center">
          <MusicalNoteIcon className="w-36 mx-auto" />
          It&apos;s free :)
        </h1>
        <h2 className="mb-6 text-xl font-medium text-left md:text-center">
          We&apos;re in the beta stage, and the service is free during the beta phase.
        </h2>
        <ul>
          <li className="mb-3">
            <p className="font-bold">
              Q. What are the credits?
            </p>
            <p>
              You need credits to create stories and slides. Credits will be deducted based on the computing power you use. Don&apos;t worry though, it&apos;s free during the beta phase.
            </p>
          </li>
          <li className="mb-3">
            <p className="font-bold">
              Q. How can I recharge the credits?
            </p>
            <p>
              We&apos;ll automatically recharge your credits and kindly ask for your participation in a survey. Your opinion is invaluable to us.
            </p>
          </li>
          <li className="mb-3">
            <p className="font-bold">
              Q. How much are the credits?
            </p>
            <p>
              The service is free during the beta phase. The price will be determined before we go into production.
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
}

export default PricingSection;
